import React, { useEffect, useRef, useState } from "react";
import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";

export default function FloorSvgPlanning({
  desks,
  floorImage,
  selectedDeskIds,
  setSelectedDeskIds,
  floorWidth = 4962,
  floorHeight = 3508
}) {

  const containerRef = useRef(null);
  const [initialScale, setInitialScale] = useState(1);

  const meta = { width: floorWidth, height: floorHeight };
  
 

  

  // --- AUTO SCALE (exact same as utilisation)
  useEffect(() => {
    const el = containerRef.current;
    if (!el) return;

    const calc = () => {
      const cw = el.clientWidth || 1;
      const ch = el.clientHeight || 1;
      setInitialScale(Math.min(cw / meta.width, ch / meta.height));
    };

    calc();
    const ro = new ResizeObserver(calc);
    ro.observe(el);
    return () => ro.disconnect();
  }, [meta.width, meta.height]);

  function toggleDesk(deskId) {
    setSelectedDeskIds(function (prev) {
      if (prev.includes(deskId)) {
        return prev.filter(function (id) {
          return id !== deskId;
        });
      }
      return prev.concat(deskId);
    });
  }

  return (
    <div
      ref={containerRef}
      style={{
        width: "100%",
        height: "100%",
        position: "relative",
        overflow: "hidden"
      }}
    >
      <TransformWrapper
        initialScale={initialScale}
        minScale={0.01}
        maxScale={8}
        wheel={{ step: 0.2 }}
        pinch={{ step: 5 }}
        doubleClick={{ disabled: true }}
        centerOnInit
      >
        <TransformComponent
          wrapperStyle={{ width: "100%", height: "100%" }}
          contentStyle={{ width: meta.width, height: meta.height }}
        >
          <svg
            width={meta.width}
            height={meta.height}
            style={{ display: "block" }}
          >

            {/* Highlight filter (reused) */}
            <defs>
              <filter id="highlight" x="-200%" y="-200%" width="400%" height="400%">
                <feDropShadow
                  dx="0"
                  dy="0"
                  stdDeviation="6"
                  floodColor="#0078ff"
                  floodOpacity="0.8"
                />
              </filter>
            </defs>

            {/* Background floor image (unchanged) */}
            <image
              href={floorImage}
              width={meta.width}
              height={meta.height}
              preserveAspectRatio="xMinYMin meet"
            />

            {/* DESKS (simple, planning-only) */}
            {desks.map(function (desk) {

              const isSelected =
                selectedDeskIds &&
                selectedDeskIds.includes(desk.spaceId);

              return (
				<path
					
				    key={"desk-" + desk.spaceId}
				    d={desk.svg}
				    fill={
				      isSelected
				        ? "rgba(255,155,0,0.85)"   // 🔥 SELECTED → brighter orange
				        : "rgba(0,120,255,0.40)"   // 😌 UNSELECTED → dialled-down blue
				    }
				    stroke={
				      isSelected
				        ? "#ff9b00"                // orange stroke for selected
				        : "rgba(0,120,255,0.45)"   // soft blue outline otherwise
				    }
				    strokeWidth={isSelected ? 4 : 2}
				    filter={isSelected ? "url(#highlight)" : "none"}
				    style={{ cursor: "pointer" }}
				    onClick={function () {
				      toggleDesk(desk.spaceId);
				    }}
				  />
              );
            })}

          </svg>
        </TransformComponent>
      </TransformWrapper>
    </div>
  );
}
